import './Footer.scss';
import { useTranslation } from "react-i18next";
import easypaylogoblack from "../../../assets/images/easypaylogoblack.png";
import easypaylogowhite from "../../../assets/images/easypaylogowhite.png";

const Footer = ({ myTheme }) => {

    const { t } = useTranslation();   // <-- This line was missing

    return (
        <footer className="footer-bottom d-flex justify-content-end align-items-center">
            <div className="footer-site-info">
                {t("common.poweredBy")}
                <img
                    alt="easypay-logo"
                    src={myTheme === "light" ? easypaylogoblack : easypaylogowhite}
                    height="50"
                />
                © {new Date().getFullYear()}
            </div>
        </footer>
    );
}

export default Footer;